import type { GuidedStage } from './guidedBuilder.types'

export const chatBuilderPath = '/chat-builder'

export function guidedStagePath(configurationId: string, stage: GuidedStage) {
  return `${chatBuilderPath}/${configurationId}/guided/${stage}`
}

export function fullBuilderPath(configurationId: string) {
  return `${chatBuilderPath}/${configurationId}`
}
